export const classSubForAdminApi = {
    heading:[
        {
            head:"Class Name"
        },
        {
            head:"Subject Name"
        },
        {
            head:"Result Serial"
        },
        {
            head:"Effective From"
        },
        {
            head:"Effective To"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        classname:"Class 5",
        subjectname:"English",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        classname:"Class 6",
        subjectname:"ICT",
        resultSerial:"2",
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
     
   
       
    ]
}